export default (theme) => ({
	hero: {
		position: "relative",
		zIndex: 2,
		height: 400,
		background: "#353535",
		width: "100%",
	},
	picture: {
		opacity: ".5",
		position: "absolute",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center center",
		backgroundSize: "cover",
		left: 0,
		top: 0,
		right: 0,
		bottom: 0,
		transition: "all .4s",
	},
	backgroundImage: {
		position: "relative",
		width: "100%",
		overflow: "hidden",
		objectFit: "cover",
		objectPosition: "center center",
		display: "block",
		height: "100%",
	},
	teamAvatar: {
		width: "100%",
		height: "100%",
		transition: "all .2s",
	},
	teamAvatarImg: {
		"transition": "transform .25s,-webkit-transform .25s,-o-transform .25s",
		"&:hover": {
			transform: "scale(1.1)",
		},
	},
	wrapper: {
		height: "600px",
		backgroundImage:
			"url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDI2IDUzMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMzI0LjkgNTExLjE0QzIwMy41NiA1OTIuMTQgMCA0MDguNDIgMCAyNjUuNzYgMCA1MS43NyAxNTIuMjggMCAyNTUuMDcgMGMxNDAuNjYgMCAyMzAuODUgMTQ2LjQgMTIzLjk3IDI2NS43Ni0xMDIuMzIgODUuMjA1IDM0LjIgMTg2LjQtNTQuMTUgMjQ1LjM4eiIgZmlsbD0iIzgwRjNENyIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)",
		backgroundPosition: "18% 60px",
		backgroundSize: "auto",
		backgroundRepeat: "no-repeat",
		backgroundColor: "#f8f9fa",
		padding: "0px 20px",
		[theme.breakpoints.down("sm")]: {
			backgroundPosition: "0 60px",
		},
		[theme.breakpoints.down("xs")]: {
			height: "auto",
			minHeight: "540px",
		},
	},
	mainH2: {
		fontSize: 48,
		lineHeight: "56px",
		[theme.breakpoints.down("sm")]: {
			fontSize: 44,
			lineHeight: "52px",
		},
		[theme.breakpoints.down("xs")]: {
			fontSize: 28,
			lineHeight: "36px",
		},
		fontWeight: 700,
		textAlign: "left",
		marginBottom: "16px",
	},
	mainH3: {
		fontSize: 20,
		lineHeight: "28px",
		[theme.breakpoints.down("sm")]: {
			fontSize: 20,
			lineHeight: "28px",
		},
		[theme.breakpoints.down("xs")]: {
			fontSize: 18,
			lineHeight: "26px",
		},
		fontWeight: 700,
		textAlign: "left",
		marginBottom: "16px",
	},
	ul: {
		paddingLeft: 20,
	},
	body: {
		"& a": {
			color: theme.palette.primary.main,
		},
		"& a:hover": {
			textDecoration: "underline",
		},
		"& strong": {
			fontWeight: 600,
		},
		"& b": {
			fontWeight: 600,
		},
		"& ul": {
			paddingBottom: 24,
		},
		"& ol": {
			paddingBottom: 24,
		},
	},
});
